import {Component, Input} from '@angular/core';
import {SearchObject} from '../../core/definitions/search-object';

@Component({
    selector: 'app-search-tile-overview-fields',
    templateUrl: './search-tile-overview-fields.component.html',
    styleUrls: ['./search-tile-overview-fields.component.scss'],
    standalone: false
})
export class SearchTileOverviewFieldsComponent {
  @Input() searchObject: SearchObject;
  @Input() viewName: string;
}
